import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/chevron-left-solid.svg'
import _imports_1 from '../../assets/filter/chevron-right-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-94e069c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column mb-3",
  id: "containerCard"
}
const _hoisted_2 = { class: "d-flex flex-row justify-content-between pb-8 align-items-center" }
const _hoisted_3 = {
  class: "d-flex flex-row gap-4",
  id: "btnsInd"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-plus"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_6 = {
  class: "col-12 card d-flex flex-column p-0",
  style: {"font-size":"17px","overflow-x":"scroll"}
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<li style=\"border-radius:10px 10px 0px 0px;min-width:930px;border-bottom:0.5px solid #F3F3F3;\" class=\"col-12 p-5 d-flex flex-row\" data-v-94e069c4><span class=\"m-0 col-2 d-flex justify-content-center subtitulo\" data-v-94e069c4>CÓDIGO</span><span class=\"m-0 col-3 d-flex justify-content-center subtitulo\" data-v-94e069c4>NOME</span><span class=\"m-0 col-2 d-flex justify-content-center subtitulo\" data-v-94e069c4>TIPO</span><span class=\"m-0 col-1 d-flex justify-content-center subtitulo\" data-v-94e069c4>RAZÃO</span><span class=\"m-0 col-2 d-flex justify-content-center subtitulo\" data-v-94e069c4>GRUPO</span><span class=\"m-0 col-2 d-flex justify-content-center subtitulo\" data-v-94e069c4>AÇÃO</span></li>", 1)
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "col-2 text-truncate d-flex gap-3 justify-content-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "18",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.4492 5.55078L17.6484 7.35156C17.4648 7.53516 17.168 7.53516 16.9844 7.35156L12.6484 3.01562C12.4648 2.83203 12.4648 2.53516 12.6484 2.35156L14.4492 0.550781C15.1797 -0.179688 16.3672 -0.179688 17.1016 0.550781L19.4492 2.89844C20.1836 3.62891 20.1836 4.81641 19.4492 5.55078ZM11.1016 3.89844L0.84374 14.1562L0.0156149 18.9023C-0.0976663 19.543 0.460927 20.0977 1.10155 19.9883L5.84765 19.1562L16.1055 8.89844C16.2891 8.71484 16.2891 8.41797 16.1055 8.23438L11.7695 3.89844C11.582 3.71484 11.2851 3.71484 11.1016 3.89844ZM4.84765 13.2773C4.6328 13.0625 4.6328 12.7188 4.84765 12.5039L10.8633 6.48828C11.0781 6.27344 11.4219 6.27344 11.6367 6.48828C11.8516 6.70313 11.8516 7.04688 11.6367 7.26172L5.62108 13.2773C5.40624 13.4922 5.06249 13.4922 4.84765 13.2773ZM3.43749 16.5625H5.31249V17.9805L2.79296 18.4219L1.57811 17.207L2.01952 14.6875H3.43749V16.5625Z",
    fill: "white"
  })
], -1))
const _hoisted_15 = {
  key: 0,
  class: "pagination d-flex justify-content-between p-4"
}
const _hoisted_16 = { style: {"min-width":"14rem","display":"flex","flex-direction":"column","align-items":"start"} }
const _hoisted_17 = { style: {"font-size":"14px"} }
const _hoisted_18 = {
  key: 0,
  style: {"font-size":"14px"}
}
const _hoisted_19 = {
  class: "d-flex flex-row gap-2 align-items-center justify-content-between",
  id: "paginationList"
}
const _hoisted_20 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_21 = ["id", "disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"12px"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick", "id"]
const _hoisted_25 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_26 = {
  key: 0,
  id: "lastPage",
  class: "me-2"
}
const _hoisted_27 = ["id", "disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"12px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_modal_create_or_update_fracionados = _resolveComponent("modal-create-or-update-fracionados")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Gestão de fracionados")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          placeholder: "Pesquise por código ou nome",
          clearable: "",
          modelValue: _ctx.inputFind,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputFind) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          placeholder: "Grupos",
          modelValue: _ctx.idGrupo,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.idGrupo) = $event)),
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeGroups, (group, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: group.nome,
                value: group.id,
                key: key
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_Button, {
          type: "button",
          text: "Adicionar produto",
          onClick: _ctx.newProduto,
          style: {"white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          type: "button",
          onClick: _cache[2] || (_cache[2] = () => _ctx.router.push('filtroVeiculos')),
          style: {"white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode("Voltar ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fracionadosArray, (produto, key) => {
        return (_openBlock(), _createElementBlock("li", {
          key: key,
          class: "listaZebra col-12 d-flex flex-row align-items-center p-3",
          style: {"color":"#464e5f","min-width":"930px"}
        }, [
          _createElementVNode("div", {
            class: "col-2 text-truncate d-flex justify-content-center texto",
            title: produto.codigoProduto || '-'
          }, _toDisplayString(produto.codigoProduto || "-"), 9, _hoisted_8),
          _createElementVNode("div", {
            class: "col-3 text-truncate d-flex justify-content-center texto",
            title: produto.descricao || '-'
          }, _toDisplayString(produto.descricao || "-"), 9, _hoisted_9),
          _createElementVNode("div", {
            class: "col-2 text-truncate d-flex justify-content-center texto",
            title: produto.tipoProduto || '-'
          }, _toDisplayString(produto.tipoProduto.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase()) || "-"), 9, _hoisted_10),
          _createElementVNode("div", {
            class: "col-1 text-truncate d-flex justify-content-center texto",
            title: produto.razao || '-'
          }, _toDisplayString(produto.razao || "-"), 9, _hoisted_11),
          _createElementVNode("div", {
            class: "col-2 text-truncate d-flex justify-content-center texto",
            title: produto.nomeGrupo || '-'
          }, _toDisplayString(produto.nomeGrupo || "-"), 9, _hoisted_12),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Button, {
              variant: "secondary",
              text: "Editar",
              onClick: ($event: any) => (_ctx.fracionadoById(produto.id), _ctx.openModal('ModalCreateOrUpdateFracionados'))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]))
      }), 128))
    ]),
    (_ctx.fracionadosArray.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, "Exibindo " + _toDisplayString(_ctx.fracionadosArray.length) + " produtos.", 1),
            (_ctx.fracionadosArray.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Produtos encontrados: " + _toDisplayString(_ctx.totalProdutosDatabase), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("ul", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "me-2",
                id: _ctx.state.currentPage === 1 ? 'btnPaginationOff' : 'btnPagination',
                disabled: _ctx.state.currentPage === 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage - 1)))
              }, _hoisted_23, 8, _hoisted_21),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageCount, (number, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  ((_ctx.state.currentPage < 4 ? key + 1 >= 1 && key + 1 <= 6 : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3) ||
                (_ctx.pageCount - _ctx.state.currentPage < 4
                  ? key + 1 >= _ctx.pageCount - 6 && key + 1 <= _ctx.pageCount
                  : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3)
                )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.setCurrentPage(number)),
                        class: "cursor-pointer",
                        id: number == _ctx.state.currentPage ? 'exibOk' : 'exibRed'
                      }, _toDisplayString(number), 9, _hoisted_24))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_25, [
              (_ctx.pageCount !== _ctx.state.currentPage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                    _createTextVNode(" ... "),
                    _createElementVNode("span", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCurrentPage(_ctx.pageCount))),
                      class: "ms-2 me-1 cursor-pointer"
                    }, _toDisplayString(_ctx.pageCount), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                id: _ctx.state.currentPage === _ctx.pageCount ? 'btnPaginationOff' : 'btnPagination',
                disabled: _ctx.state.currentPage === _ctx.pageCount,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage + 1)))
              }, _hoisted_29, 8, _hoisted_27)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal_create_or_update_fracionados, {
      onCloseModal: _ctx.closeModal,
      fracionadosSelected: _ctx.fracionadosSelected,
      storeGroups: _ctx.storeGroups
    }, null, 8, ["onCloseModal", "fracionadosSelected", "storeGroups"])
  ]))
}